import { Badge, Button, IconButtonProps } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'

interface TriggerIconButtonProps extends Omit<IconButtonProps, 'icon' | 'color'> {
  icon?: IconButtonProps['icon']
  count?: number
}

export const TriggerIconButton = ({ count, icon, ...rest }: TriggerIconButtonProps): ReactElement => {
  return (
    <Button variant="outlined" icon={icon || 'notepadText'} {...rest}>
      {count ? (
        <Styled.BadgeWrapper>
          <Badge>{count}</Badge>
        </Styled.BadgeWrapper>
      ) : undefined}
    </Button>
  )
}
